interface DirectionTextProps {
  as?: React.ElementType
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  [key: string]: unknown
}

export default function DirectionText({
  as: Tag = "div",
  children,
  className = "",
  style = {},
  ...props
}: DirectionTextProps) {
  const childrenText = typeof children === "string" ? children : ""

  const dir = getDirection(childrenText)

  return (
    <Tag
      dir={dir}
      className={className}
      style={{
        textAlign: dir === "rtl" ? "right" : "left",
        fontFamily: "Noto Kufi Arabic, sans-serif",
        ...style,
      }}
      {...props}
    >
      {children}
    </Tag>
  )
}
function getDirection(text: string) {
  const firstChar = text && text.trim().charAt(0)
  const arabicRegex = /[\u0600-\u06FF]/
  return arabicRegex.test(firstChar) ? "rtl" : "ltr"
}
